import type { HttpErrorResponse } from '@angular/common/http';

import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';
import type { UnbiasedHiringSettings } from '@recruitee/candidate-evaluation-settings-types';

const { actions, reducer, namespace, selectors } =
  createSingleEntityStore<UnbiasedHiringSettings>()(
    'candidate-evaluation-unbiased-hiring-settings',
    {
      customActions: adapter => ({
        update: (state, payload: { feature: keyof UnbiasedHiringSettings; enabled: boolean }) =>
          adapter.markAsPending(state),
        updateSuccess: (state, payload: UnbiasedHiringSettings) =>
          pipeState(
            state,
            next => adapter.save(next, payload),
            next => adapter.markAsLoaded(next),
          ),
        updateFailed: (state, payload: { error: HttpErrorResponse }) =>
          pipeState(
            state,
            next => adapter.setError(next, payload),
            next => adapter.markAsLoaded(next),
          ),
      }),
    },
  );

const UnbiasedHiringSettingsActions: Pick<
  typeof actions,
  'fetch' | 'fetchSuccess' | 'fetchFailed' | 'update' | 'updateSuccess' | 'updateFailed'
> = actions;

const UnbiasedHiringSettingsSelectors = selectors;

export {
  UnbiasedHiringSettingsActions,
  UnbiasedHiringSettingsSelectors,
  reducer as UnbiasedHiringSettingsReducer,
  namespace as UnbiasedHiringSettingsNamespace,
};
